import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { CommonService } from '../../services/commom.service';
import { Step } from '../../business-entities/step.class';
import { Panel } from '../../business-entities/panel.class';
import * as Enums from '../../utils/enums';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';

@Component({
    selector: 'app-booking-steps',
    templateUrl: 'booking-steps.component.html',
    styleUrls: ['./booking-steps.component.css']
})
export class BookingStepsComponent implements OnInit, OnDestroy {

    steps: Step[] = [];
    panels: Panel[] = [];
    activeIds: string[] = [Enums.PanelIds.Panel1];
    stepsSub: Subscription;
    panelSub: Subscription;
    panelIds = Enums.PanelIds;

    constructor(
        public commonService: CommonService,
        private readonly globalSetting: GlobalSetting,
        private readonly translate: TranslateService,
        private readonly modalService: NgbModal,
    ) {
    }

    ngOnInit(): void {
        this.steps = this.commonService.getSteps();
        this.panels = this.commonService.getPanels();
        this.stepsSub = this.commonService.stepsChanged.subscribe((steps: Step[]) => this.steps = steps);
        this.panelSub = this.commonService.panelsChanged.subscribe((panels: Panel[]) => this.panels = panels);
        this.globalSetting.bookingWidget.subscribe((res) => {
            if(res){
                this.openPanel(Enums.PanelIds.Panel1);
            }
        });
        this.commonService.isCreationExpired.subscribe((res)=>{
            if (res) {
                this.RefreshConfirmPopup()
            }
        })
    }
    
    RefreshConfirmPopup(){
        let modelHeadermsg = this.translate.instant('lblTimeout');
        let modelBodymsg = this.translate.instant('lblTimeoutMessage');
        const updatedModalRef = this.modalService.open(NgInfoModalContent);
        updatedModalRef.componentInstance.modelHeader = modelHeadermsg;
        updatedModalRef.componentInstance.modelBody = modelBodymsg;
        updatedModalRef.result.then((_result) => { 
            this.clearPanel3Data();
           }, (_reason) => {
            this.clearPanel3Data();
          });
    }
    clearPanel3Data(){
        this.commonService.removeSlotSelections();
        this.openPanel(Enums.PanelIds.Panel3);
    }

    openPanel(panelId: string): void {
        this.setIsActivePropertyOfPanel(panelId);
        this.closePanelsExcept(panelId);
    }

    setIsActivePropertyOfPanel(openingPanelPanelId: string) {
        this.panels.forEach(x => {
            if (x.PanelId === openingPanelPanelId) {
                x.isActive = true;
            } else { x.isActive = false; }
        });
    }

    closePanelsExcept(panelId: string): void {
        this.activeIds = [];
        this.activeIds.push(panelId);
    }

    tryOpeningPanel(panelId: string): void {
        if (this.commonService.canGoToPanel(panelId)) {
            this.openPanel(panelId);
            if(panelId == Enums.PanelIds.Panel3)
            {
                window.scrollTo(0, 200);
            }
        }
    }


    ngOnDestroy(): void {
        this.panelSub.unsubscribe();
        this.stepsSub.unsubscribe();
        this.commonService.isCreationExpired.unsubscribe();
    }
}
